var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex float-left vertical-center"},[_c('span',{on:{"click":_vm.showPopup}},[_vm._v(_vm._s(this.params.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }